import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Truck, Clock, Package, MapPin } from "lucide-react";

const DeliveryTab: React.FC = () => {
  return (
    <div className="relative space-y-6 pointer-events-auto">
      <Card>
        <CardContent className="relative z-10 p-6">
          <div className="flex items-center gap-3 mb-4">
            <Truck className="h-5 w-5 text-primary" />
            <h3 className="text-lg font-semibold">Shipping Options</h3>
          </div>
          <div className="space-y-4">
            <div className="flex justify-between items-center p-3 rounded-lg bg-muted/50">
              <div className="flex items-center gap-3">
                <Clock className="h-4 w-4 text-muted-foreground" />
                <div>
                  <p className="font-medium">Standard Shipping</p>
                  <p className="text-sm text-muted-foreground">5-7 business days</p>
                </div>
              </div>
              <span className="font-semibold text-primary">Free</span>
            </div>
            <div className="flex justify-between items-center p-3 rounded-lg bg-muted/50">
              <div className="flex items-center gap-3">
                <Package className="h-4 w-4 text-muted-foreground" />
                <div>
                  <p className="font-medium">Express Shipping</p>
                  <p className="text-sm text-muted-foreground">2-3 business days</p>
                </div>
              </div>
              <span className="font-semibold">$9.99</span>
            </div>
            <div className="flex justify-between items-center p-3 rounded-lg bg-muted/50">
              <div className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-muted-foreground" />
                <div>
                  <p className="font-medium">Next Day Delivery</p>
                  <p className="text-sm text-muted-foreground">1 business day</p>
                </div>
              </div>
              <span className="font-semibold">$19.99</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="relative z-10 p-6">
          <h3 className="text-lg font-semibold mb-4">Delivery Information</h3>
          <div className="space-y-3 text-sm">
            <p>• Orders placed before 2 PM EST ship the same business day</p>
            <p>• Free shipping on orders over $75</p>
            <p>• We ship Monday through Friday (excluding holidays)</p>
            <p>• Tracking information will be provided once your order ships</p>
            <p>• Signature may be required for high-value items</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DeliveryTab;